import { render, staticRenderFns } from "./Component-TaskFeedbackList.vue?vue&type=template&id=7976b849&"
import script from "./Component-TaskFeedbackList.vue?vue&type=script&lang=js&"
export * from "./Component-TaskFeedbackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports